export const PRODUCT_STOCK_GET = 'PRODUCT_STOCK_GET';
export const PRODUCT_STOCK_SUCCESS = 'PRODUCT_STOCK_SUCCESS';
export const PRODUCT_STOCK_ERROR = 'PRODUCT_STOCK_ERROR';

export const TYPE_MOVEMENTS_GET = 'TYPE_MOVEMENTS_GET';
export const TYPE_MOVEMENTS_SUCCESS = 'TYPE_MOVEMENTS_SUCCESS';

export const PRODUCT_MOVEMENT_CREATE = 'PRODUCT_MOVEMENT_CREATE';
export const PRODUCT_MOVEMENT_CREATE_SUCCESS = 'PRODUCT_MOVEMENT_CREATE_SUCCESS';

export const PRODUCT_STOCK_REMOVE = 'PRODUCT_STOCK_REMOVE';
export const PRODUCT_STOCK_REMOVE_SUCCESS = 'PRODUCT_STOCK_REMOVE_SUCCESS';

export const PRODUCT_MOVEMENTS_GET = 'PRODUCT_MOVEMENTS_GET';
export const PRODUCT_MOVEMENTS_SUCCESS = 'PRODUCT_MOVEMENTS_SUCCESS';
export const PRODUCT_MOVEMENT_DELETE = 'PRODUCT_MOVEMENT_DELETE';
export const PRODUCT_MOVEMENT_DELETE_SUCCESS = 'PRODUCT_MOVEMENT_DELETE_SUCCESS';

// "Prix d'achat HT" — a product_movement quantity:0 row used purely to
// record a purchase price, independent of real stock in/out movements.
export const PRODUCT_PURCHASE_PRICE_GET = 'PRODUCT_PURCHASE_PRICE_GET';
export const PRODUCT_PURCHASE_PRICE_SUCCESS = 'PRODUCT_PURCHASE_PRICE_SUCCESS';
export const PRODUCT_PURCHASE_PRICE_SET = 'PRODUCT_PURCHASE_PRICE_SET';
export const PRODUCT_PURCHASE_PRICE_SET_SUCCESS =
	'PRODUCT_PURCHASE_PRICE_SET_SUCCESS';
export const PRODUCT_PURCHASE_PRICE_DELETE = 'PRODUCT_PURCHASE_PRICE_DELETE';
export const PRODUCT_PURCHASE_PRICE_DELETE_SUCCESS =
	'PRODUCT_PURCHASE_PRICE_DELETE_SUCCESS';
export const PRODUCT_PURCHASE_PRICE_BULK_SET = 'PRODUCT_PURCHASE_PRICE_BULK_SET';
export const PRODUCT_PURCHASE_PRICE_BULK_SET_SUCCESS =
	'PRODUCT_PURCHASE_PRICE_BULK_SET_SUCCESS';
export const PRODUCT_PURCHASE_PRICE_BULK_DELETE = 'PRODUCT_PURCHASE_PRICE_BULK_DELETE';
